import { CustomTemplatedMessageVariables } from 'generated-graphql/types';
import { fillTemplatedMessage } from 'utils/fillTemplatedMessage';
import { ReviewInvitationsCandidateItem } from '../shared-steps';
import { CampaignCreationSharedJobInformationFormData } from 'modules/campaign-creation-shared/forms';

type GetSourcingSharedSubjectLineProps = {
  formSubjectLine: string | undefined;
  agentName: string;
  candidate: ReviewInvitationsCandidateItem;
  jobInformationFormData: CampaignCreationSharedJobInformationFormData;
  jobPostingUrl: string | null;
  organizationName: string;
};

export const getSourcingSharedSubjectLine = ({
  formSubjectLine,
  agentName,
  candidate,
  jobInformationFormData,
  jobPostingUrl,
  organizationName
}: GetSourcingSharedSubjectLineProps): string | undefined => {
  if (!formSubjectLine) return;
  const templateVariables = [
    {
      value: CustomTemplatedMessageVariables.CandidateFirstName,
      label: candidate.fullName.split(' ')[0]
    },
    {
      value: CustomTemplatedMessageVariables.CandidateLastName,
      label: candidate.fullName.split(' ').slice(1).join(' ')
    },
    {
      value: CustomTemplatedMessageVariables.JobTitle,
      label: jobInformationFormData?.jobTitle ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.Location,
      label: jobInformationFormData?.location ?? ''
    },
    {
      value: CustomTemplatedMessageVariables.OrganizationName,
      label: organizationName
    },
    {
      value: CustomTemplatedMessageVariables.JobApplicationUrl,
      label: jobPostingUrl || ''
    },
    {
      value: CustomTemplatedMessageVariables.AgentName,
      label: agentName
    },
    {
      value: CustomTemplatedMessageVariables.EmployerName,
      label: jobInformationFormData?.employerName ?? ''
    }
  ];

  const filledSubject = fillTemplatedMessage(
    formSubjectLine,
    templateVariables
  );

  return filledSubject;
};
